import {
  IgGlobalFilters,
  insightsiqPlatformWorkIdMap,
  YtGlobalFilters,
} from "../constants";

export const queryToInsightsIqConverter = (
  body: { [key: string]: any },
  limit: number,
  offset: number,
  work_platform_id: string
) => {
  let tempObj: { [key: string]: any } = {
    sort_by: {
      field: "FOLLOWER_COUNT",
      order: "DESCENDING",
    },
  };

  if (body["username"]) {
    tempObj = {
      ...tempObj,
      platform_username: {
        value: body["username"],
        operator: "PREFIX",
      },
    };
  }
  Object.keys(body || {}).forEach((item) => {
    const globalFilter =
      work_platform_id === insightsiqPlatformWorkIdMap["instagram"]
        ? IgGlobalFilters.find((igItem) => igItem.facetName === item)
        : YtGlobalFilters.find((ytItem) => ytItem.facetName === item);

    if (globalFilter && globalFilter.facetName === "subscriber_count") {
      tempObj = {
        ...tempObj,
        subscriber_count: {
          min: body[item]["min"],
          max: body[item]["max"],
        },
      };
    }

    if (globalFilter && globalFilter.facetName === "follower_count") {
      tempObj = {
        ...tempObj,
        follower_count: { min: body[item]["min"], max: body[item]["max"] },
      };
    }

    if (
      globalFilter &&
      globalFilter.facetName === "topics" &&
      body[item]?.length > 0
    ) {
      tempObj = {
        ...tempObj,
        topic_relevance: {
          name: body[item],
          weight: 0.5,
          threshold: 0.55,
        },
      };
    }

    if (
      globalFilter &&
      globalFilter.facetName === "creator_locations" &&
      body[item]?.length > 0
    ) {
      tempObj = {
        ...tempObj,
        creator_locations: body[item],
      };
    }

    if (
      globalFilter &&
      globalFilter.facetName === "description_keywords" &&
      body[item] &&
      body[item] !== ""
    ) {
      tempObj = {
        ...tempObj,
        description_keywords: body[item],
      };
    }

    if (
      globalFilter &&
      globalFilter.facetName === "bio_phrase" &&
      body[item] &&
      body[item] !== ""
    ) {
      tempObj = {
        ...tempObj,
        bio_phrase: body[item],
      };
    }

    if (globalFilter && globalFilter.facetName === "content_count") {
      tempObj = {
        ...tempObj,
        content_count: { min: body[item]["min"], max: body[item]["max"] },
      };
    }

    if (
      globalFilter &&
      globalFilter.facetName === "creator_gender" &&
      body[item]
    ) {
      tempObj = {
        ...tempObj,
        creator_gender: body[item],
      };
    }

    if (globalFilter && globalFilter.facetName === "creator_age") {
      tempObj = {
        ...tempObj,
        creator_age: { min: body[item]["min"], max: body[item]["max"] },
      };
    }

    if (globalFilter && globalFilter.facetName == "is_verified") {
      tempObj = {
        ...tempObj,
        is_verified: body[item],
      };
    }

    if (
      globalFilter &&
      globalFilter.facetName === "last_post_timestamp" &&
      body[item]
    ) {
      tempObj = {
        ...tempObj,
        last_post_timestamp: body[item],
      };
    }

    if (
      globalFilter &&
      globalFilter.facetName === "creator_language" &&
      body[item] &&
      body[item] !== ""
    ) {
      tempObj = {
        ...tempObj,
        creator_language: {
          code: body[item],
        },
      };
    }

    if (
      globalFilter &&
      globalFilter.facetName === "creator_interests" &&
      body[item]
    ) {
      tempObj = {
        ...tempObj,
        creator_interests: [body[item]],
      };
    }

    if (
      globalFilter &&
      globalFilter.facetName === "creator_account_type" &&
      body[item]?.length > 0
    ) {
      tempObj = {
        ...tempObj,
        creator_account_type: body[item],
      };
    }

    if (
      globalFilter &&
      globalFilter.facetName === "hashtags" &&
      body[item]?.length > 0
    ) {
      tempObj = {
        ...tempObj,
        hashtags: body[item]?.map((item: any) => ({ name: item })),
      };
    }

    if (
      globalFilter &&
      globalFilter.facetName === "mentions" &&
      body[item]?.length > 0
    ) {
      tempObj = {
        ...tempObj,
        mentions: body[item]?.map((item: any) => ({ name: item })),
      };
    }

    if (globalFilter && globalFilter.facetName === "audience_locations") {
      console.log("body[item]", body[item]);
      tempObj = {
        ...tempObj,
        audience_locations: [
          {
            location_id: body[item].value,
            percentage_value: body[item].min || 1,
            operator: "GT",
          },
        ],
      };
    }

    if (
      globalFilter &&
      globalFilter.facetName === "audience_age" &&
      body[item]
    ) {
      tempObj = {
        ...tempObj,
        audience_age: {
          min: body[item]?.value?.min || undefined,
          max: body[item]?.value?.max || undefined,
          percentage_value: body[item]?.min || 1,
        },
      };
    }

    if (
      globalFilter &&
      globalFilter.facetName === "audience_gender" &&
      body[item]
    ) {
      tempObj = {
        ...tempObj,
        audience_gender: {
          type: body[item]?.value || "",
          operator: "GT",
          percentage_value: body[item]?.min || 1,
        },
      };
    }

    if (
      globalFilter &&
      globalFilter.facetName === "audience_language" &&
      body[item]
    ) {
      tempObj = {
        ...tempObj,
        audience_language: [
          {
            code: body[item].value,
            percentage_value: body[item].percentage || 1,
          },
        ],
      };
    }

    if (
      globalFilter &&
      (globalFilter.facetName === "audience_brand_affinities" ||
        globalFilter.facetName === "creator_brand_affinities") &&
      body[item]?.length > 0
    ) {
      tempObj = {
        ...tempObj,
        [item]: body[item],
      };
    }

    if (
      globalFilter &&
      globalFilter.facetName === "audience_interest_affinities" &&
      body[item]?.length > 0
    ) {
      tempObj = {
        ...tempObj,
        audience_interest_affinities:
          body[item]?.map(
            (ele: { value: string | number; percentage: number }) => {
              return {
                value: ele.value,
                operation: "GT",
                percentage_value: ele.percentage || 1,
              };
            }
          ) || [],
      };
    }

    if (
      globalFilter &&
      (globalFilter.facetName === "average_likes" ||
        globalFilter?.facetName === "average_views")
    ) {
      tempObj = {
        ...tempObj,
        [item]: { min: body[item]["min"], max: body[item]["max"] },
      };
    }

    if (globalFilter && globalFilter.facetName === "engagement_rate") {
      tempObj = {
        ...tempObj,
        engagement_rate: {
          percentage_value: body[item] || 1,
        },
      };
    }

    if (globalFilter && globalFilter.facetName == "has_sponsored_posts") {
      tempObj = {
        ...tempObj,
        has_sponsored_posts: body[item],
      };
    }

    if (
      globalFilter &&
      globalFilter.facetName == "brand_sponsors" &&
      body[item]?.length > 0
    ) {
      tempObj = {
        ...tempObj,
        brand_sponsors: body[item],
      };
    }

    if (
      globalFilter &&
      globalFilter.facetName === "instagram_options_reel_views" &&
      body[item]
    ) {
      tempObj = {
        ...tempObj,
        instagram_options: {
          reel_views: { min: body[item]["min"], max: body[item]["max"] },
        },
      };
    }

    if (
      globalFilter &&
      (globalFilter.facetName === "subscriber_growth" ||
        globalFilter.facetName === "follower_growth") &&
      body[item]
    ) {
      tempObj = {
        ...tempObj,
        [item]: {
          interval: body[item].value,
          interval_unit: "MONTH",
          operator: "GT",
          percentage_value: body[item].percentage,
        },
      };
    }

    if (
      globalFilter &&
      (globalFilter.facetName === "audience_lookalikes" ||
        globalFilter?.facetName === "creator_lookalikes") &&
      body[item] &&
      body[item] !== ""
    ) {
      tempObj = {
        ...tempObj,
        [item]: body[item],
      };
    }
  });

  tempObj = {
    ...tempObj,
    sort_by: body?.sort_by || tempObj?.sort_by,
    limit: limit || 10,
    offset: offset || 0,
    work_platform_id,
    instagram_options:
      work_platform_id === insightsiqPlatformWorkIdMap["instagram"]
        ? !tempObj?.instagram_options
          ? {
              reel_views: { min: 0 },
            }
          : tempObj?.instagram_options
        : undefined,
    average_views:
      work_platform_id === insightsiqPlatformWorkIdMap["youtube"]
        ? !tempObj?.average_views
          ? {
              average_views: { min: 0 },
            }
          : tempObj?.average_views
        : undefined,
  };

  return tempObj;
};
